export default "__VITE_ASSET__B94uWn86__"